import type {
  ComboboxItem,
  ComboboxLikeRenderOptionInput,
} from "@mantine/core";
import type { ComponentType, ReactNode } from "react";

export function mantineRenderOption<T extends ComboboxItem>(
  Item: ComponentType<T & { checked?: boolean }>,
): (input: ComboboxLikeRenderOptionInput<T>) => ReactNode {
  return ({ option, checked }: ComboboxLikeRenderOptionInput<T>) => (
    <Item {...option} checked={checked} />
  );
}
